import { jsx as _jsx } from "react/jsx-runtime";
import { UploadStatus } from "@air/redux-uploader";
import { UploadPreviewLoader } from "../ui/UploadPreviewLoader";
export const convertUploadToFileTrackingPaneItem = (upload, progressInfo)=>{
    return {
        id: upload.id,
        status: upload.status,
        error: upload.status === UploadStatus.failed ? upload.errorMessage ? upload.errorMessage : "Failed" : "",
        ext: upload.apiUploadData.ext,
        title: upload.apiUploadData.importedName,
        sizeInBytes: upload.apiUploadData.size || 0,
        thumbnailSource: upload.imageBase64,
        currentBytesUploaded: (progressInfo === null || progressInfo === void 0 ? void 0 : progressInfo.progress) || 0,
        previewLoader: /*#__PURE__*/ _jsx(UploadPreviewLoader, {
            upload: upload
        })
    };
};
